.input-wrapper {
  display: grid;
  grid-gap: 1rem;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: min-content min-content auto;

  & > div {
    display: grid;
    align-items: center;
    grid-auto-flow: column;
    grid-auto-columns: min-content;
  }

  & > div:last-child {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.time-input {
  &__hours {
    text-align: left;
    min-width: 4rem;
  }

  &__minutes {
    min-width: 3rem;
  }

  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.clear-button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.75rem;

  background: var(--color-gray-50);

  border: 0;
  cursor: pointer;

  &:hover {
    background: var(--color-gray-300);
  }

  &__icon {
    font-size: 16px;
  }
}
